export type CardType = CardTypeEnum.ADD_NEW_CARD | CardTypeEnum.FILLED | CardTypeEnum.VOID;

export enum CardTypeEnum {
  VOID = 'void',
  ADD_NEW_CARD = 'addNewCard',
  FILLED = 'filled'
}
